export default function getCategoryMediaUrlPrefix(type, cdnUrl) {
  if (type === 'sticker') {
    return 'sticker';
  }
  if (/\.gif/i.test(cdnUrl)) {
    return 'gif';
  }
  return 'image';
}
